import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchNotificationsByUser = (userId) => {
  return apiClient(`${ENDPOINTS.NOTIFICATIONS_BY_USER}/${userId}`, {
    method: "GET",
  });
};

export const markNotificationAsSeen = (notificationId) => {
  return apiClient(`${ENDPOINTS.NOTIFICATIONS}/${notificationId}/seen`, {
    method: "PUT",
  });
};
